import axios, { AxiosInstance } from "axios";
import authhHeader from "../../core/utils/authh.header";

class Notifications {
  private readonly request: AxiosInstance;

  constructor(request: AxiosInstance) {
    this.request = request;
  }

  private createAxiosInstance(): AxiosInstance {
    return axios.create({
      baseURL: import.meta.env.VITE_PLATOON_BASEURL,
      headers: authhHeader(),
    });
  }

  async fetchNotifications(
    userId: number,
    pageSize = 10,
    pageNumber = 1
  ): Promise<any> {
    const customRequest = this.createAxiosInstance();

    try {
      const response = await customRequest.get(
        `/Notification/retrieve-notification`,
        {
          params: {
            UserId: userId,
            PageSize: pageSize,
            PageNumber: pageNumber,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching notifications:", error);
      return Promise.reject(error);
    }
  }

  // POST method to create a new notification
  async createNotification(payload: {
    userId: number;
    roleId: number;
    organisationId: number;
    platoon: boolean;
    subject: string;
    body: string;
  }): Promise<any> {
    const customRequest = this.createAxiosInstance();

    try {
      const response = await customRequest.post(`Notification/send`, payload);
      return response.data;
    } catch (error) {
      console.error("Error creating notification:", error);
      return Promise.reject(error);
    }
  }

  // PUT method to mark notification as read
  async markAsRead(notificationId: number): Promise<any> {
    const customRequest = this.createAxiosInstance();

    try {
      const response = await customRequest.put(
        `/Notification/mark-notification-asRead/${notificationId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error marking notification as read:", error);
      return Promise.reject(error);
    }
  }

  // PUT method to mark all notifications as read for a user
  async markAllAsRead(userId: number): Promise<any> {
    const customRequest = this.createAxiosInstance();

    try {
      const response = await customRequest.put(
        `/Notification/mark-notification-asRead/${userId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error marking all notifications as read:", error);
      return Promise.reject(error);
    }
  }

  // DELETE method to delete a single notification
  async deleteNotification(notificationId: number): Promise<any> {
    const customRequest = this.createAxiosInstance();

    try {
      const response = await customRequest.delete(`/Notification/${notificationId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting notification:", error);
      return Promise.reject(error);
    }
  }

  // DELETE method to delete all notifications
  async deleteAllNotifications(): Promise<any> {
    const customRequest = this.createAxiosInstance();

    try {
      const response = await customRequest.delete(`/Notification/all`);
      return response.data;
    } catch (error) {
      console.error("Error deleting all notifications:", error);
      return Promise.reject(error);
    }
  }
}

export default new Notifications(axios);
